import Cookies from 'js-cookie'

const tokenKey = 'x-token'
const userinfoKey = 'sr.user'

export default {
  state: {
    token: '',
    // userinfo: function() {
    //   console.log(Cookies.get(userinfoKey))
    //   if (Cookies.get(userinfoKey) !== undefined) {
    //     return JSON.parse(Cookies.get(userinfoKey))
    //   } else {
    //     return {}
    //   }
    // }
    userinfo: Cookies.get(userinfoKey) ? JSON.parse(Cookies.get(userinfoKey)) : {}
  },
  getters: {
    token: state => {
      if (
        state.token === null ||
        state.token === undefined ||
        state.token === ''
      ) {
        // state.token = sessionStorage.getItem(tokenKey);
        state.token = Cookies.get(tokenKey)
      }
      return state.token
    },

    userinfo: state => {
      // if (Cookies.get(userinfoKey) !== undefined) {
      //   state.userinfo = JSON.parse(Cookies.get(userinfoKey))
      // } else {
      //   state.userinfo = {}
      // }
      return state.userinfo
    }
  },
  mutations: {
    setToken: (state, token) => {
      state.token = token
      // sessionStorage.setItem(tokenKey, token);
      Cookies.set(tokenKey, token)
    },
    setUserInfo: (state, userData) => {
      state.userinfo = userData
      Cookies.set(userinfoKey, JSON.stringify(userData), { expires: 7 }) // 7天过期
    }
  },
  actions: {}
}
